const faqs = [
  {
    q: '爱豆影视是否需要注册才能观看？',
    a: '完全不需要注册。爱豆影视所有内容免费开放，打开网站即可直接观看高清电视剧、电影和综艺节目，无任何使用门槛。',
  },
  {
    q: '播放时会出现卡顿或缓冲吗？',
    a: '爱豆影视采用先进的CDN加速和多线路智能调度技术，确保高清画质下流畅播放不缓冲。如遇网络波动，系统会自动切换最优线路。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '爱豆影视全面支持电脑、平板和手机端观看，自适应屏幕尺寸。画质方面提供流畅、高清、超清多种选择，部分热门内容支持4K画质，带来极致观影体验。',
  },
  {
    q: '更新速度快吗？最新热播剧什么时候上线？',
    a: '爱豆影视保持与播出平台同步更新，热门电视剧、综艺通常在播出后数小时内即可在线观看。电影资源持续补充，高分经典和最新院线片均有覆盖。',
  },
  {
    q: '内容资源是否安全可靠？会不会有广告？',
    a: '爱豆影视所有内容来源于互联网公开资源，平台本身不存储视频文件。播放页面清爽干净，无弹窗广告干扰，让用户专注于观影本身。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于爱豆影视，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2.5 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}